<script lang="ts">
	export let size: sizeType = 'normal';
	export let inline = false;

	type sizesType = {
		[key in sizeType]: number;
	};

	type sizeType = 'normal' | 'large';

	const sizes: sizesType = {
		large: 27,
		normal: 18, //default
	};
</script>

<div class={`px-spinner spinner`}>
	<span
		style="display:{inline ? 'inline-block' : 'block'};
            block-size:{sizes[size]}px;
            inline-size: {sizes[size]}px;
            inset-block-start: calc(50% - {sizes[size] / 2 + 2}px);
			inset-inline: calc(50% - {sizes[size] / 2 + 2}px) calc(50% - {sizes[size] / 2 + 2}px);
            "
	>
		<div style=" block-size:{sizes[size]}px;inline-size: {sizes[size]}px" />
	</span>
</div>

<style>
	@keyframes spin {
		from {
			transform: rotate(0deg);
		}

		to {
			transform: rotate(360deg);
		}
	}

	.spinner {
		margin-inline: auto;
	}

	div {
		position: relative;
	}

	div > span {
		position: relative;
		border: 2px solid rgb(0 0 0 / 20%);
		border-radius: 100%;
	}

	div > span > div {
		display: inline-block;
		animation: spin 800ms linear infinite;
		border: 2px solid rgb(0 0 0 / 70%);
		border-radius: 100%;
		border-block-end-color: rgb(0 0 0 / 70%);
		inset-inline-start: -2px;
		inset-block-start: -2px;
		border-block-start-color: transparent;
		border-inline-start-color: transparent;
		border-inline-end-color: transparent;
	}
</style>
